export const FETCH_USER_WORK_EXPERIENCE_REQUEST = 'FETCH_USER_WORK_EXPERIENCE_REQUEST'
export const FETCH_USER_WORK_EXPERIENCE_SUCCESS = 'FETCH_USER_WORK_EXPERIENCE_SUCCESS'
export const FETCH_USER_WORK_EXPERIENCE_FAILED = 'FETCH_USER_WORK_EXPERIENCE_FAILED'
export const FETCH_USER_WORK_EXPERIENCE_QUICK_UPLOAD_RESUME =
  'FETCH_USER_WORK_EXPERIENCE_QUICK_UPLOAD_RESUME'
